import { cn } from "../../../utils/formatting";
import DesktopSidebar from "./DesktopSidebar";
import { MobileHeader } from "../mobile/mobile-header";
import { Outlet } from "react-router-dom";

const DashboardLayout = ({ className }) => {
  return (
    <div
      className={cn(
        "flex flex-col lg:flex-row gap-2 min-h-[100vh] w-full",
        className,
      )}
    >
      <aside>
        <MobileHeader />
        <div className="w-[300px] lg:block hidden">
          <DesktopSidebar />
        </div>
      </aside>
      <main className="h-[90vh] md:h-[100vh] overflow-y-auto w-full">
        <Outlet />
      </main>
    </div>
  );
};

export default DashboardLayout;
